import { TrackApi, TrackPointApi } from './tracks.backend-model';
import { Track, TrackPoint } from './tracks.model';

export function transformTracks(track: TrackApi): Track {
  return {
    id: track.id,
    userId: track.userId,
    projectId: track.projectId,
    trackPoints: transformTrackPoints(track.trackPoints),
    timeStarted: track.timeStarted * 1000,
    timeFinished: track.timeFinished ? track.timeFinished * 1000 : undefined,
  };
}

function transformTrackPoints(
  trackPoints: ReadonlyArray<TrackPointApi>,
): ReadonlyArray<TrackPoint> {
  return trackPoints.map(trackPoint => ({
    longitude: trackPoint.longitude,
    latitude: trackPoint.latitude,
    timeCreated: trackPoint.timeCreated
      ? trackPoint.timeCreated * 1000
      : undefined,
  }));
}
